import { render, staticRenderFns } from "./deleteProductPriceRule.vue?vue&type=template&id=beaf192a"
import script from "./deleteProductPriceRule.vue?vue&type=script&lang=js"
export * from "./deleteProductPriceRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports